import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backroundColor: '#ffffff',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const LoginRequiredDialog = withStyles((theme) => ({
    paper: {
      backgroundColor: '#ffffff'
    },
}))(Dialog);

const LoginRequiredDialogCloseButton = withStyles((theme) => ({
    root: {
        color: theme.palette.primary.main
    },
}))(Button);


const LoginRequiredAlert = ({loginAlertOpen, setLoginRequiredAlertClose}) => {
  return (
    <div>
      <LoginRequiredDialog onClose={setLoginRequiredAlertClose} aria-labelledby="customized-dialog-title" open={loginAlertOpen}>
        <DialogTitle id="customized-dialog-title" onClose={setLoginRequiredAlertClose}>
          Login to Upload Photos
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            Please login to upload photos.
          </Typography>
          <Typography gutterBottom>
            You must be a logged in user in order to submit photos for a trail. 
          </Typography>
          <Typography gutterBottom>
            If you don't have an account, you can create one for free.
          </Typography>
          <Typography gutterBottom>
            Click the Login button and choose sign in from the dropdown menu to create an account.
          </Typography>
        </DialogContent>
        <DialogActions>
          <LoginRequiredDialogCloseButton autoFocus onClick={setLoginRequiredAlertClose}>
            Close
          </LoginRequiredDialogCloseButton>
        </DialogActions>
      </LoginRequiredDialog>
    </div>
  );
}

export default LoginRequiredAlert;